<template>
  <!-- パンくずリスト -->
  <div class="p-breadcrumb" :class="additionalClasses">
    <ul class="p-breadcrumb-list">
      <li v-for="(element,index) in breadcrumbData" :key="index" class="p-breadcrumb-list__item">
        <a v-if="index!=breadcrumbData.length-1" :href="element.url">{{ element.title }}</a>
        <span v-if="index==breadcrumbData.length-1">{{ element.title }}</span>
      </li>
    </ul>
  </div>
<!-- /パンくずリスト -->
</template>

<script>
export default {
  props: {
    breadcrumbData: Array,
    additionalClasses: Array,
  },
}
</script>
